import { useState } from "react";

import { useEventListener } from "usehooks-ts";

export type DisconnectedStateStatus = "offline" | "online" | "reconnected" | "outdated";

declare global {
	interface WindowEventMap {
		disconnectedStateChange: CustomEvent<DisconnectedStateStatus>;
	}
}

export function useDisconnectedState(defaultValue: DisconnectedStateStatus = "online") {
	const [disconnectedState, setDisconnectedState] =
		useState<DisconnectedStateStatus>(defaultValue);

	useEventListener("disconnectedStateChange", (event) => {
		setDisconnectedState(event.detail);
	});

	const isOnAuthPage = window.location.pathname.startsWith("/auth");

	return {
		disconnectedState,
		isDisconnected:
			!isOnAuthPage && (disconnectedState === "offline" || disconnectedState === "outdated"),
	};
}

export const emitDisconnectedState = (newValue: DisconnectedStateStatus) => {
	window.dispatchEvent(
		new CustomEvent<DisconnectedStateStatus>("disconnectedStateChange", {
			detail: newValue,
		}),
	);
};
